import { LineChartSeriesType } from './types';

export const getMainPathConfig = ({
  name,
  data,
  color,
  annotations,
  shouldHideFromTooltip = false,
  tooltipYearValue,
}: Pick<
  LineChartSeriesType,
  'name' | 'data' | 'color' | 'annotations' | 'shouldHideFromTooltip' | 'tooltipYearValue'
>): LineChartSeriesType => {
  return {
    name,
    data,
    color,
    type: 'line',
    stroke: {
      width: 4,
      dashArray: 0,
      curve: 'straight',
    },
    annotations,
    shouldHideFromTooltip,
    tooltipYearValue,
  };
};
